import { gql } from '~gql-types/gql'

/** @public */
export const THREAD_FRAGMENT = gql(`
  fragment ThreadFields on Thread {
    id
    title
    members {
      ...UserFields
    }
    network {
      id
      timezone
      title
      features
      settings {
        id
        dateFormat
      }
    }
  }
`)

export const FETCH_USER_MESSAGE_THREADS = gql(`
  query FetchUserMessageThreads {
    loggedInUser {
      id
      messageThreads {
        ...ThreadFields
      }
    }
  }
`)

export const FETCH_THREAD_MESSAGES = gql(`
  query FetchThreadMessages($threadId: ID!, $params: MessageParams) {
    findThread(id: $threadId) {
      id
      ...ThreadFields
      messageCount
      messages(params: $params) {
        id
        body
        createdAt
        author {
          ...UserFields
        }
        viewedByUser
        viewedByAll
      }
    }
  }
`)

export const ADD_THREAD_MESSAGE = gql(`
  mutation AddThreadMessage($threadId: ID!, $message: String!, $networkId: ID) {
    addThreadMessage(threadId: $threadId, message: $message, networkId: $networkId) {
      id
      body
      createdAt
      author {
        ...UserFields
      }
      viewedByUser
      viewedByAll
    }
  }
`)

export const CREATE_THREAD = gql(`
  mutation CreateThread($memberIds: [ID!]!, $networkName: String!) {
    createThread(memberIds: $memberIds, networkName: $networkName) {
      ...ThreadFields
    }
  }
`)

export const FIND_SHARED_THREADS = gql(`
  query FindSharedThreads($memberIds: [ID!]!) {
    loggedInUser {
      id
      sharedThreads(memberIds: $memberIds) {
        ...ThreadFields
      }
    }
  }
`)

export const FETCH_USER_CONTACTS = gql(`
  query FetchUserContacts($params: ContactParams!) {
    loggedInUser {
      id
      contacts(params: $params) {
        contacts {
          ...UserFields
        }
        totalCount
      }
    }
  }
`)

export const DELETE_THREAD = gql(`
  mutation DeleteThread($threadId: ID!) {
    deleteThread(threadId: $threadId) {
      id
    }
  }
`)

export const DELETE_THREAD_MESSAGE = gql(`
  mutation DeleteThreadMessage($messageId: ID!) {
    deleteThreadMessage(messageId: $messageId)
  }
`)

export const ADD_MESSAGE_VIEW = gql(`
  mutation AddMessageView($messageId: ID!, $networkId: ID!) {
    addMessageView(messageId: $messageId, networkId: $networkId) {
      id
      viewedByUser
      viewedByAll
    }
  }
`)

export const OPEN_DIRECT_THREAD = gql(`
  mutation OpenDirectThread($userId: ID!, $networkName: String!) {
    openDirectThread(userId: $userId, networkName: $networkName) {
      id
    }
  }
`)

export const RESOLVE_THREAD_BY_LEGACY_EID = gql(`
  query ResolveThreadByLegacyEid($legacyEid: String!) {
    resolveThreadByLegacyEid(legacyEid: $legacyEid) {
      id
    }
  }
`)
